import Vue from 'vue'
import Vuex from 'vuex'

const STORE_ACCESS_TOKEN_NAME = 'nhb_bonbon_at'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        accessToken: null,
    },

    mutations: {
        setAccessToken (s, token) {
            s.accessToken = token
            localStorage.setItem(STORE_ACCESS_TOKEN_NAME, token)
        },
    },

    actions: {
        init ({ commit }) {
            const at = localStorage.getItem(STORE_ACCESS_TOKEN_NAME)
            if (at) {
                commit('setAccessToken', at)
            }
        },

        logout ({ commit }) {
            commit('setAccessToken', null)
            localStorage.removeItem(STORE_ACCESS_TOKEN_NAME)
        },
    },

    getters: {
        isAuthenticated: s => s.accessToken,
    },
})
